<template>
  <article class="content-error-view ">
    <div v-show="isUnspecifiedError" id="error500">
      <h1>Unknown Error</h1>
      <img :src="unknownErrorIcon" alt="Unknow error logo">
      <div class="content-error-title">Technical Support:</div>
      <div class="content-error-information">
        <dl id="phones">
          <dt>Toll-free Phone number:</dt>
          <dd>+1-800-998-6374</dd>
          <dt>International Phone Number:</dt>
          <dd>+1-781-392-2000</dd>
        </dl>
        <dl id="mail_mobile">
          <dt>Email:</dt>
          <dd> <a href="mailto:support@uptodate.com">support@uptodate.com</a><br>  </dd>
        </dl>
        <dl id="atention">
          <dt>Support Center Hours:</dt>
          <dd>Monday - Friday, 7 AM - 9 PM ET (-5 GMT)</dd>
          <dt>Current Support Center Time & Date:</dt>
          <dd>Monday, September 12, 2023 11:36 AM ET (-5 GMT)</dd>
        </dl>
        <dl id="mail_desktop">
          <dt>Email:</dt>
          <dd> <a href="mailto:support@uptodate.com">support@uptodate.com</a><br>  </dd>
        </dl>
      </div>
    </div>
    <div v-show="isSecurityAgentError" class="security-agent-error">
      <h1>Security Agent Sign In Failed</h1>
      <div class="security-agent-information">
        <ul>
          <li><strong>Security Agent Name:</strong> {{ securityAgentParams.securityAgentName }}</li>
          <li><strong>Session ID:</strong> {{ securityAgentParams.sessionId }}</li>
          <template v-if="areIssuedDateAndSystemDatePresent">
            <li><strong>Issued Date:</strong> {{ formattedIssuedDate }}</li>
            <li><strong>System Date:</strong> {{ formattedSystemDate }}</li>
          </template>
        </ul>
        <!-- eslint-disable-next-line max-len -->
        Please contact <a href="mailto:sitesupport@uptodate.com">sitesupport@uptodate.com</a> for more information.
      </div>
    </div>
    <EmailVerificationRequiredError v-if="isEmailVerificationRequiredError"
                                    :title="errorTitle"
                                    :message="translatedErrorMessage" />
    <div v-show="!isUnspecifiedError && !isSecurityAgentError && !isEmailVerificationRequiredError">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p v-html="translatedErrorMessage" />
    </div>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import unknownErrorIcon from '~_acaAssets/utd-menu/unknown-error-icon.svg';
import EmailVerificationRequiredError
    from '_acaSrc/components/error/EmailVerificationRequiredError.vue';

export default {
    components: {
        EmailVerificationRequiredError
    },
    data() {
        return { unknownErrorIcon };
    },
    computed: {
        ...mapGetters('error', [
            'errorTitle',
            'errorMessage',
            'errorParams',
            'isUnspecifiedError',
            'isSecurityAgentError',
            'securityAgentParams'
        ]),
        translatedErrorMessage() {
            return this.$t(`${this.errorMessage}`, this.errorParams);
        },
        isEmailVerificationRequiredError() {
            return this.errorTitle === 'Email Verification Required';
        },
        areIssuedDateAndSystemDatePresent() {
            return this.formattedIssuedDate && this.formattedSystemDate;
        },
        formattedIssuedDate() {
            return this.securityAgentParams.issuedDateTimestamp
                ? new Date(this.securityAgentParams.issuedDateTimestamp).toUTCString()
                : null;
        },
        formattedSystemDate() {
            return this.securityAgentParams.systemDateTimestamp
                ? new Date(this.securityAgentParams.systemDateTimestamp).toUTCString()
                : null;
        }
    }
};
</script>
<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.content-error-view {
  padding: 40px 62px;
  text-align: center;

  h1 {
    align-items: center;
    font-size: 28px;
    line-height: 36px;
    font-weight: 400;
    margin: 0;
  }

  img {
    .ds1-mv-5();
    width: 112px;
    height: 112px;
  }

  #error500 {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.content-error-information {
  text-align: left;
  display: flex;
  flex-direction: column;
}

.content-error-information,
.content-error-title {
  width: 100%;
  text-align: left;
  max-width: 684px;
}

.content-error-title {
  .ds1-pb-3();
  .ds1-mb-2();
  .ds1-utd-weight-600();
  /* stylelint-disable-next-line declaration-property-value-no-unknown */
  border-bottom: 1px solid @UTD-LEGACY-WHITE-TINT5;
}

.content-error-information dl {
  margin-block: 0;
}

.content-error-title,
dl dd,
dl dt {
  color: @WKCE-GRAY-SHADE2;
  font-size: 14px;
  line-height: 18px;
}

dl dt {
  .ds1-utd-weight-300();
}

dl dd {
  .ds1-utd-weight-500();
  .ds1-mb-2();
}

dl dd a {
  color: @WKCE-BLUE-SHADE1;
}

#mail_desktop {
  display: none;
}

.security-agent-error {
  text-align: center;

  > h1 {
    font-size: 28px;
  }

  .security-agent-information {
    .ds1-mv-5();
    text-align: left;
    display: inline-block;

    > ul {
      .ds1-pa-0;
      list-style-type: none;
      overflow-wrap: anywhere;
    }

    > a {
      color: @WKCE-BLUE;
    }
  }
}

.largeScreenStyles {
  .content-error-view {
    padding: 0;
    margin-top: 56px;

    h1 {
      font-size: 60px;
    }

    img {
      width: 224px;
      height: 224px;
      margin: 64px 0;
    }
  }

  .content-error-title {
    .ds1-mb-3();
    font-size: 16px;
    line-height: 22px;
  }

  .content-error-information {
    flex-direction: row;
  }

  .content-error-information dl {
    .ds1-ph-3();
    margin-block: 0;
    width: 40.2%;
  }

  .content-error-information dl:first-child {
    .ds1-pl-0();
    width: 31.9%;
  }

  .content-error-information dl:last-child {
    .ds1-pr-0();
    width: 27.5%;
  }

  .content-error-information dl:not(:last-child) {
    /* stylelint-disable-next-line declaration-property-value-no-unknown */
    border-right: 1px solid @UTD-LEGACY-WHITE-TINT5;
  }

  #mail_mobile {
    display: none;
  }

  #mail_desktop {
    display: block;

    dl {
      float: right;
    }
  }

  dl dd {
    .ds1-utd-weight-600();
  }

  #phones dd:not(:last-child) {
    margin-bottom: 36px;
  }
}

@media only screen and (min-width: 1140px) and (orientation: landscape) {
  .largeScreenStyles();
}
</style>